import { HttpClientModule } from '@angular/common/http';
import { Injector, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared';
import { CookieService } from 'ngx-cookie-service';
import { NgPipesModule } from 'ngx-pipes';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ThemingService } from './core/helperclasses/theming.service';
import { PosthogService } from './core/posthog.service';
import { SURVEY_SERVICE } from './core/survey-service-interface';
import { DialogsModule } from './dialogs/dialogs.module';
import { SurveyPopoverModule } from './dialogs/survey-popover/survey-popover.module';
import { MaterialModule } from './material.module';
import { ShellModule } from './shell/shell.module';

// import { ChapterCardModuleModule } from './page-modules/chapter-preview-module/chapter-preview-module.module';
// import { HeaderModuleModule } from './page-modules/header-module/header-module.module';
import { LoginModule } from './pages/login/login.module';
import { ResetPasswordModule } from './pages/reset-password/reset-password.module';
import { AppLoadService } from './app-load.service';

export let AppInjector: Injector;

export interface MatOptions {
  appearance?: string;
  floatLabel?: string;
}

const matFormFieldDefaultOptions: MatOptions = {
  appearance: 'outline',
  // floatLabel: 'auto',
};

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    TranslateModule.forRoot(),
    BrowserAnimationsModule,
    MaterialModule,
    MatIconModule,
    SharedModule,
    ShellModule,
    RouterModule,
    LoginModule,
    ResetPasswordModule,
    NgPipesModule,
    DialogsModule,
    SurveyPopoverModule,
    // HeaderModuleModule,
    // ChapterCardModuleModule,
    AppRoutingModule, // must be imported as the last module as it contains the fallback route
  ],
  declarations: [AppComponent],
  providers: [
    CookieService,
    {
      provide: LOCALE_ID,
      useValue: 'de-DE', // 'de-DE' for Germany, 'fr-FR' for France ...
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: matFormFieldDefaultOptions,
    },
    ThemingService,
    AppLoadService,
    { provide: SURVEY_SERVICE, useExisting: PosthogService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
